import { GlobalThemeOverrides, MenuProps } from "naive-ui"

const borderRadiusButton = {
    borderRadiusMedium: "6px",
    borderRadiusLarge: "6px",
    borderRadiusSmall: "6px",
    borderRadiusTiny: "6px",
};

const borderRadiusInput = {
    borderRadius: "6px",
    color: "#f5f6fa"
};
  
const loadingTheme = {
    colorLoading: "#0883da",
    colorError: "#EC5555"
};

type MenuThemeOverrides = NonNullable<MenuProps['themeOverrides']>;
export const menuThemeOverrides = {
    color: '#3D7AA5',
    itemTextColor: '#FFFFFF',
    itemTextColorActive: '#000000',
    itemTextColorActiveHover: '#000000',
    itemTextColorHover: '#FFFFFFF',
    itemIconColor: '#FFFFFF',
    itemIconColorHover: '#FFFFFFF',
    itemIconColorActive: '#000000',
    
    itemIconColorActiveHover: '#000000',
    itemColorActive: '#ffffff',
    itemColorHover: '#ffffff25',
    itemColorActiveHover: '#ffffff',
    itemColorActiveCollapsed: '#ffffff',
    itemIconColorCollapsed: '#FFFFFF',
    itemIconColorActiveCollapsed: '#000000'
  } as MenuThemeOverrides;

  export const themeOverrides = {
    common: {
      primaryColor: "#3D7AA5",
      primaryColorHover: "#356587",
      primaryColorPressed: "#264C67",
      warningColor: "#E8A117",
      warningColorHover: "#CB8D14",
      warningColorPressed: "#91650E",
      errorColor: "#EC5555",
      errorColorHover: "#E83131",
      errorColorPressed: "#B41414",
      successColor: "#00BB34",
      successColorHover: "#00A42E",
      successColorPressed: "#007521",
    },
    Button: borderRadiusButton,
    Input: borderRadiusInput,
    DatePicker: borderRadiusInput,
    InputNumber: borderRadiusInput,
    LoadingBar: loadingTheme,
    Select: {
      peers: {
        InternalSelection: borderRadiusInput,
        InternalSelectMenu: {
          borderRadius: "6px",
        }
      }
    },
  } as GlobalThemeOverrides;